module.exports = __webpack_public_path__ + "static/media/periodicInvest.c17e6e01.svg";